<template>
    <div class="px-4 py-6">
        <Header :show-details="false" :show-menu="false" :centered="true"></Header>
        <div class="mt-8 text-center">
            <div v-if="loading" class="text-gray-600">Loading QR code...</div>
            <div v-else-if="!exists" class="text-lg text-brandBlue">This QR code could not be found.</div>
            <div v-else-if="scanned" class="text-lg text-brandBlue">This QR code has already been scanned.</div>
            <div v-else>
                <h1 class="text-xl text-brandBlue mb-4">Your QR Code</h1>
                <img v-if="image" :src="image" alt="QR Code" class="mx-auto bg-white p-2" style="width: 85%" />
                <p v-if="shortCode" class="mt-6 text-sm text-gray-600">Manual code</p>
                <p v-if="shortCode" class="text-3xl tracking-widest text-brandBlue">{{ shortCode }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/views/partials/Header'
import axios from 'axios'
import QRCode from 'qrcode'
import { onBeforeMount, ref } from 'vue'

export default {
    name: 'QrCode',
    components: {
        Header
    },
    props: {
        token: {
            required: true,
            type: String
        }
    },
    setup (props) {
        const loading = ref(true)
        const exists = ref(false)
        const scanned = ref(false)
        const image = ref('')
        const shortCode = ref('')

        onBeforeMount(() => {
            axios.get(process.env.VUE_APP_API_URL + '/public/qr/' + props.token)
                .then(async (response) => {
                    exists.value = response.data.exists
                    scanned.value = response.data.scanned
                    shortCode.value = response.data.short_code || ''

                    if (exists.value && !scanned.value) {
                        image.value = await QRCode.toDataURL(props.token, {
                            width: 800,
                            margin: 2
                        })
                    }
                })
                .catch(() => {
                    exists.value = false
                    scanned.value = false
                })
                .finally(() => {
                    loading.value = false
                })
        })

        return {
            loading,
            exists,
            scanned,
            image,
            shortCode
        }
    }
}
</script>
